import Name from "./name/Name";
import About from "./about/About";
import Skills from "./skills/Skills";
import Projects from "./projects/Projects";

function Home() {
  return (
    <div>
      <Name />
      <About />
      <Skills />
      <Projects />
    </div>
  );
}

export default Home;
